import Route from '@ember/routing/route';
import type Router from '@ember/routing/router';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import SessionService from 'donor-elf-web/services/session';

export default class FundRoute extends Route {
  @service declare router: Router;
  @service declare session: SessionService;

  async beforeModel(transition: Transition) {
    await this.session.requireAuthentication(transition, 'login');
  }

  redirect() {
    this.router.transitionTo('funds.fund.dashboard');
  }
}
